import { render, staticRenderFns } from "./BranchServicer.vue?vue&type=template&id=26f54cce&"
import script from "./BranchServicer.vue?vue&type=script&lang=ts&"
export * from "./BranchServicer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports